import { addMinutes, format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import style from './style.module.scss';

interface IProps {
  aiDateTime?: string;
  createdBy?: string;
  userTimezone: number;
}

const ActionItemInfo: React.FC<IProps> = ({ aiDateTime, createdBy, userTimezone }) => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();
  const dateFormat = `${profileData?.dateFormat.date} ${profileData?.dateFormat.time}`;

  const createdDateTime = aiDateTime
    ? format(addMinutes(aiDateTime, userTimezone), dateFormat)
    : '-';

  return (
    <div className={style.aiInfoBlock}>
      {t('Created')}{' '}
      <span className={style.aiInfo}>
        {createdDateTime} by {createdBy || ''}
      </span>
    </div>
  );
};

export default ActionItemInfo;
